module.exports = __webpack_public_path__ + "static/media/Lato-Italic.af5a576d.eot";